import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["openModal", "openBanner"];
  connect(event) {
    this.element.addEventListener('turbo:submit-end', (event) => {
      if (event.detail.success) {
        this.close();
      }
    });
  }

  openBanner() {
    this.openBannerTarget.classList.toggle("hidden");
  }
  open() {
    this.openModalTarget.classList.toggle("hidden");

  }
  close() {
    this.openModalTarget.classList.add("hidden");
    this.openBannerTarget.classList.add("hidden");
  }


}
